import { type ComponentProps, memo } from "react"
import { Layer as _Layer, Map as _Map, Marker as _Marker, Source as _Source } from "react-map-gl/mapbox"

import { useMountedGuard } from "../../hooks/utils"
import { useMapLoad } from "../hooks"

export const Source = memo<ComponentProps<typeof _Source>>((props) => {
	const mounted = useMountedGuard()
	const [loaded, styleLoaded] = useMapLoad()
	if (!mounted || !loaded || !styleLoaded) return null
	return <_Source {...props} />
})
Source.displayName = "Source"

export const Layer = memo<ComponentProps<typeof _Layer>>((props) => {
	const mounted = useMountedGuard()
	const [loaded, styleLoaded] = useMapLoad()
	if (!mounted || !loaded || !styleLoaded) return null
	return <_Layer {...props} />
})
Layer.displayName = "Layer"

export const Marker = memo<ComponentProps<typeof _Marker>>((props) => {
	const mounted = useMountedGuard()
	const [loaded, styleLoaded] = useMapLoad()
	if (!mounted || !loaded || !styleLoaded) return null
	return <_Marker {...props} />
})
Marker.displayName = "Marker"

export const Map = memo<ComponentProps<typeof _Map>>((props) => {
	const mounted = useMountedGuard()
	if (!mounted) return null
	return <_Map {...props} />
})
Map.displayName = "Map"
